import React from "react";
import { createStore, applyMiddleware } from "redux";
import { Provider } from "react-redux";
import { composeWithDevTools } from "redux-devtools-extension";
import createSagaMiddleware from "redux-saga";
import reducers, { saga } from "../../redux/reducers";

const sagaMiddleware = createSagaMiddleware();

let devTools = applyMiddleware( sagaMiddleware );
devTools = composeWithDevTools( devTools );

const store = createStore( reducers, devTools );

sagaMiddleware.run( saga );

const ReduxProvider = props => <Provider store={ store }>{ props.children }</Provider>;

export default ReduxProvider;
export { store };
